import React from 'react';
import styled from 'styled-components';

const Breadcrumb = ({ currentFolder, onFolderClick }) => {
  // Generate breadcrumb path array
  const generatePath = () => {
    if (!currentFolder) return [{ name: 'Recording', path: '' }];
    
    const parts = currentFolder.split('/').filter(part => part);
    const breadcrumbs = [{ name: 'Recording', path: '' }];
    
    let currentPath = '';
    parts.forEach(part => {
      currentPath += `${part}/`;
      breadcrumbs.push({
        name: part,
        path: currentPath
      });
    });
    
    return breadcrumbs;
  };

  const breadcrumbItems = generatePath();

  return (
    <BreadcrumbContainer>
      {breadcrumbItems.map((item, index) => (
        <React.Fragment key={`breadcrumb-${index}`}>
          {index > 0 && <Separator><i className="fas fa-chevron-right"></i></Separator>}
          <BreadcrumbItem
            onClick={() => onFolderClick(item.path)}
            isActive={index === breadcrumbItems.length - 1}
          >
            {item.name}
          </BreadcrumbItem>
        </React.Fragment>
      ))}
    </BreadcrumbContainer>
  );
};

// Styled Components
const BreadcrumbContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 10px 15px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  margin-bottom: 15px;
  border: 1px solid var(--glass-border);
`;

const BreadcrumbItem = styled.div`
  padding: 5px 8px;
  font-size: 14px;
  color: ${props => props.isActive ? 'var(--primary-color)' : 'var(--text-color)'};
  font-weight: ${props => props.isActive ? '600' : '400'};
  cursor: pointer;
  border-radius: 5px;
  transition: var(--transition);
  
  &:hover {
    background: ${props => props.isActive ? 'transparent' : 'rgba(0, 160, 233, 0.1)'};
    color: var(--primary-color);
  }
`;

const Separator = styled.span`
  color: var(--text-light);
  font-size: 12px;
  margin: 0 2px;
  display: flex;
  align-items: center;
`;

export default Breadcrumb; 